module.exports = __webpack_public_path__ + "static/media/logo-light.ee64f393.svg";